import apiClient from './apiClient';

const SettingsService = {
  getSettings: async () => {
    const res = await apiClient.get('/settings');
    return res.data || res;
  }
};

export default SettingsService;
